

export enum AddUserType {
    TASK_USER       = 'TASK_USER',
    PROJECT_USER    = 'PROJECT_USER',
    WORKSPACE_USER  = 'WORKSPACE',
    CHAT_USER       = 'CHAT_USER',
    MEETING_USER    = 'MEETING_USER',
}